<script>
// http://localhost/?quicklink=0dce6670160d28c1945769b03fbac413#/
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { componentStore } from "@common/componentStore/componentStore";
import { configStore } from "@common/configStore";
import { actionStore } from "@common/actionStore";
import { library } from "@common/library/library";
import { recordStore } from "@common/recordStore";

const editorSettings = {
    tabs: {
        label: 'Tabs list',
        type: 'ARRAY',
        id: 'tabsList',
        itemConfig: {
            primaryLabel: 'Tab',
            itemType: 'object',
            permissions: {
                allowAddItem: true,
            },
            keys: {
                tabName: {
                    type: 'string',
                    id: 'tabName',
                    label: 'Tab Name',
                    helpText: 'Create name for tab'
                },
                tabTemplate: {
                    type: 'text',
                    id: 'tabTemplate',
                    label: 'Tab template',
                    helpText: 'Input config for tab template or component'
                    // ENABLE_HTML: true
                }
            },
            newItem: {
                textProp: 'a new text prop',
                numberProp: 1
            }
        },
        helpText: 'Tabs configuration for webPostings'
    },
};

const webPostingManagerConfig = {
    cId: "webPostingManager",
    cType: "webPostingManager",
    cTitle: "Web Posting Manager",
    cTemplate: `<div>
        <div class="top-controls-container">
            <div class="search-controls">
                <condensed-filter
                    :prop-filter-options="filterOptions"
                    :prop-item-label="'Web Posting'"
                    :cId="'condensedFilter__' + cId"
                    :prop-filter-items="mappedPostings"
                    :prop-result="filteredItems"
                    @update:prop-result="filteredItems = $event; filteredItemsUpdated()"
                    :prop-filtering="filtering"
                    @update:prop-filtering="filtering = $event"
                ></condensed-filter>
                <control name="showInactivePostings"></control>
            </div>
            <control name="NEW_POSTING_BUTTON"></control>
            <!-- <control name="SAVE_ALL" v-if="VUE_PROJECT_NAME === 'devDash'"></control> -->
            <teleport v-if="showCreateNewPosting" to="#NEW_POSTING_CONTROLS">
                <div v-if="contextOrg" class="alert alert-primary instructions">
                    <i class="fa fa-info-circle">{{}}</i>
                    <div>
                        <h3 v-if="contextOrg.ORG_TITLE">Create a posting for {{contextOrg.ORG_TITLE}}</h3>
                        <p>
                            Use a Web Posting to display the details of this entry point to the public  using the eRecruiter search page.
                            The listing provides volunteers with details for the <strong>Assignment Entry Point</strong>.
                            One organization can be chosen from each hierarchy. A minimum of one Organization must be selected.
                        </p>
                    </div>
                </div>
                <control name="AFF_ORG_1"></control>
                <control name="AFF_ORG_2"></control>
                <control name="AFF_ORG_3"></control>
                <control name="EXISTING_POSTING_MESSAGE"></control>
            </teleport>
        </div>
        <hr/>
        <div v-for="(record, postingIndex) in visiblePostings"
            :key="postingIndex"
            class="web-posting-container"
        >
            <transition name="fade">
                <div class="posting-item" v-show="record.AFF_STATUS === 'Active' || showInactivePostings">
                    <div style="display: flex">
                        <div class="aff-org-image-container">
                            <img v-for="(org, key) in record.AFFILIATED_ORGS" :key="key" :src="org['ATTACHURL#Image'] + 'small'" title="Organization Image" class="aff-org-image"/>
                        </div>
                        <div>
                            <h2 class="posting-title">
                                <div v-for="(org, key) in record.AFFILIATED_ORGS" class="posting-title-org">
                                    <div class="posting-title-name">
                                        <div class="posting-tier">{{org.ORG_KIND}}</div>
                                        {{org.ORG_TITLE}}
                                    </div>
                                    <div class="aff-separator">and{{}}</div>
                                </div>
                            </h2>
                            <div class="publish-state-indicators">
                                <div class="status-indicator" :class="[record.AFF_STATUS === 'Active' ? 'active' : 'inactive']">{{record.AFF_STATUS}}</div>
                                <div class="endpoint-url">
                                    <i class="fa fa-share">{{}}</i>
                                    <a :href="recruiterUrl + '/affiliation_details/' + record.postingId" target="_blank" title="Website URL (entry-point)">Open Link</a>
                                    <i class="fa-regular fa fa-copy">{{}}</i>
                                    <a @click="copyLink(record.postingId)"><span v-if="templateData[record.postingId].linkCopied">Copied!</span><span v-else>Copy Link</span></a>
                                </div>
                            </div>
                            <button type="button" class="e-control e-btn e-primary" @click="showingDetails[record.postingId] = !showingDetails[record.postingId]">View Details</button>
                        </div>
                    </div>
                    <div v-if="showingDetails[record.postingId]">
                        <ul class="posting-tabs">
                            <li @click="templateData[record.postingId].currentView='search'" :class="{ active: !templateData[record.postingId].currentView || templateData[record.postingId].currentView === 'search' }" title="Search Settings">Search Settings</li>
                            <li @click="templateData[record.postingId].currentView='details'" :class="{ active: templateData[record.postingId].currentView === 'details' }" title="Details">Web Details</li>
                            <li @click="templateData[record.postingId].currentView='signups'" :class="{ active: templateData[record.postingId].currentView === 'signups' }" title="Sign-up History">Sign-up History</li>
                            <li @click="templateData[record.postingId].currentView='admin'" :class="{ active: templateData[record.postingId].currentView === 'admin' }" title="admin">Admin</li>
                            <li v-for="tab in config.tabs" @click="templateData[record.postingId].currentView=tab.tabName" :class="{ active: templateData[record.postingId].currentView === tab.tabName }" :title="tab.tabName" >{{tab.tabName}}</li>
                        </ul>
                        <div v-if="!templateData[record.postingId].currentView || templateData[record.postingId].currentView === 'search'" class="posting-tab-container">
                            <div>
                                <control :name="'DISPLAY_IN_SEARCH__' + record.postingId"></control>
                            </div>
                            <div v-if="controls['DISPLAY_IN_SEARCH__' + record.postingId] && controls['DISPLAY_IN_SEARCH__' + record.postingId].value !== 'hide'">
                                <button type="button" class="help-button e-control e-btn e-link" @click="templateData[record.postingId].showAvailWindowsHelp = !templateData[record.postingId].showAvailWindowsHelp">
                                    <i class="fa fa-info-circle">{{}}</i> Help
                                </button>
                                <h2>Sign Up Windows</h2>
                                <div class="alert alert-primary instructions" v-show="templateData[record.postingId].showAvailWindowsHelp">
                                    <i class="fa fa-info-circle">{{}}</i>
                                    <p>
                                        Use Sign Up Windows to limit access to your Assignment Entry Points.
                                        Each window can be scheduled in the future, for a limited time or quantity of sign-ups, or both.
                                        Additionally, display windows allows volunteers to see when sign-ups begin.
                                    </p>
                                </div>
                                <div v-if="loadingWindows">Loading Availability Windows... please wait.</div>
                                <div v-if="Object.keys(availabilityWindows[record.postingId]).length">
                                    <div v-for="window in availabilityWindows[record.postingId]" class="posting-window-item">
                                        <div class="window-action-buttons">
                                            <div style="flex-grow: 9;">
                                                <button type="button" class="e-control e-btn e-link" @click="expandAaw(record.postingId, window.aawId)">
                                                    {{window.AAW_SIGNUP_START_DATE ? window.AAW_SIGNUP_END_DATE : 'Window ' + window.aawId + ':'}}
                                                    {{!window.AAW_SIGNUP_START_DATE && !window.AAW_MAX_VOLUNTEERS ? 'Unrestricted Sign-up' : ''}}
                                                    {{window.AAW_SIGNUP_END_DATE ? ' - ' + window.AAW_SIGNUP_END_DATE : ''}}
                                                    {{window.AAW_MAX_VOLUNTEERS ? ' (' + window.AAW_MAX_VOLUNTEERS + ')' : ''}}
                                                    <i class="fa fa-chevron-right"></i>
                                                </button>
                                            </div>
                                            <button type="button" class="e-control e-btn e-link"
                                                v-show="!templateData[record.postingId].expandedWindows[window.aawId]"
                                                @click="expandAaw(record.postingId, window.aawId)"
                                            >
                                                edit
                                            </button>
                                            <control v-if="templateData[record.postingId]?.expandedWindows[window.aawId]" :name="'UPDATE_AVAILABILITY_WINDOW__' + window.aawId + '__' + record.postingId" :actionParams="[window.aawId, record.postingId]"></control>
                                        </div>
                                        <div v-if="templateData[record.postingId].expandedWindows[window.aawId]">
                                            <div class="posting-window-details">
                                                <div class="posting-window-dates">
                                                    <div class="signup-dates-block">
                                                        <div class="signup-dates-controls">
                                                            <div>
                                                                <control :name="'AAW_SIGNUP_START_DATE__' + window.aawId + '__' + record.postingId"></control>
                                                                <control :name="'AAW_SIGNUP_START_TIME__' + window.aawId + '__' + record.postingId"></control>
                                                            </div>
                                                            <div>
                                                                <control :name="'AAW_SIGNUP_END_DATE__' + window.aawId + '__' + record.postingId"></control>
                                                                <control :name="'AAW_SIGNUP_END_TIME__' + window.aawId + '__' + record.postingId"></control>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="display-dates-block" v-if="controls['DISPLAY_IN_SEARCH__' + record.postingId] && controls['DISPLAY_IN_SEARCH__' + record.postingId].value === 'windows'">
                                                        <div class="display-dates-controls">
                                                            <control :name="'AAW_DISPLAY_START_DATE__' + window.aawId + '__' + record.postingId"></control>
                                                            <control :name="'AAW_DISPLAY_END_DATE__' + window.aawId + '__' + record.postingId"></control>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <control :name="'AAW_MAX_VOLUNTEERS__' + window.aawId + '__' + record.postingId"></control>
                                                </div>
                                            </div>
                                            <control style="position: absolute; bottom: 1rem; right: 0"  :name="'DELETE_AVAILABILITY_WINDOW__' + window.aawId + '__' + record.postingId" :actionParams="[window.aawId, record.postingId]"></control>
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-top: 1rem;">
                                    <p  v-if="!loadingWindows && Object.keys(availabilityWindows[record.postingId]).length === 0">No Availability Windows.  Click "New Window" to create one.</p>
                                    <div style="display: flex;">
                                        <control name="NEW_AVAILABILITY_WINDOW" :actionParams="record.postingId"></control>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="templateData[record.postingId].currentView === 'details'" class="posting-tab-container">
                            <div class="action-button-container">
                                <control v-if="Array.isArray(record.DETAIL_RECORD_ID) && record.DETAIL_RECORD_ID.length" name="EDIT_DETAILS_BUTTON__edit" label="Edit Detail Record" :actionParams="record.postingId" :disabled="templateData[record.postingId].detailRecordLoading"></control>
                                <control v-else name="EDIT_DETAILS_BUTTON__new" label="Customize Posting Details" :actionParams="record.postingId" :disabled="templateData[record.postingId].detailRecordLoading"></control>
                                <div v-if="templateData[record.postingId].detailRecordLoading" class="detail-record-loading-indicator">loading...</div>
                            </div>
                            <div v-if="Array.isArray(record.DETAIL_RECORD_ID) && record.DETAIL_RECORD_ID.length">
                                <div><strong>Detail Record: {{record.DETAIL_RECORD_ID[0]}}</strong></div>
                                <h1>{{record.DETAIL_RECORD.ORG_TITLE}}</h1>
                                <div class="description-header">Short Description:</div>
                                <div class="short-description">
                                    {{record.DETAIL_RECORD.ORG_SHORT_DESCRIPTION}}
                                </div>
                                <div class="description-header">
                                    Long Description:
                                    <button type="button" style="border: 0 none; font-size: 16px; background: transparent; text-decoration: underline;" @click="templateData[record.postingId].showLongDesc = !templateData[record.postingId].showLongDesc">Show Long Description</button>
                                </div>
                                <div class="long-description" v-if="templateData[record.postingId].showLongDesc && record.DETAIL_RECORD?.ORG_LONG_DESCRIPTION">
                                    <div v-html="record.DETAIL_RECORD.ORG_LONG_DESCRIPTION"></div>
                                </div>
                            </div>
                            <div v-else>
                                <div>
                                    <strong>Detail Record:</strong>
                                    <span style="color: #479a2a; font-weight: bold; cursor: pointer;">Standard Template</span>
                                </div>
                                <div class="instructions alert detail-record-info">
                                    <i class="fa fa-info-circle">{{}}</i>
                                    <p>
                                        <strong>Note: </strong>Default details is a combination of the "location" and "sub-program" details.  If you want to customize these details click "Customize Posting Details".
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div v-if="templateData[record.postingId].currentView === 'signups'" class="posting-tab-container">
                            <div><strong>Volunteers Who've Signed Up</strong></div>
                            <div v-if="Object.keys(availabilityWindows[record.postingId]).length">
                                <div v-for="window in availabilityWindows[record.postingId]">
                                    <p>
                                        <span v-if="!window.AAW_SIGNUP_START_DATE && !window.AAW_SIGNUP_END_DATE">Unrestricted window</span>
                                        <span v-else><strong>{{window.AAW_SIGNUP_START_DATE}} - {{window.AAW_SIGNUP_END_DATE}}</strong></span>
                                    </p>
                                    <ul class="vol-signup-list" v-if="window.VOL_SIGNUP_LIST.length">
                                        <li v-for="signupVol in window.VOL_SIGNUP_LIST">{{signupVol.VOL_FIRST_NAME}} {{signupVol.VOL_LAST_NAME}}</li>
                                    </ul>
                                    <div v-else>
                                        <p>No Sign-ups yet.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="templateData[record.postingId].currentView === 'admin'" class="posting-tab-container">
                            <div style="display: flex;">
                                <div style="margin-right: 20px;">
                                    <strong>Workflows (in order):</strong><br/>
                                    <ul>
                                        <li v-for="workflow in record.ATTACHED_WORKFLOWS">{{workflow.WORKFLOW_TITLE}}</li>
                                    </ul>
                                </div>
                            </div>
                            <div>
                                <h3>Expire this Posting.</h3>
                                <p>
                                    Expiring the posting will set it to an "expired" status. This will prevent it from displaying publicly, regardless of any configured posting windows.  To undo this, you can re-activate the posting.<br/><br/>
                                    <strong>Note:</strong> This will not change reporting for volunteers/supervisors that have already applied to this posting and been given an assignment.  To change status with individuals, you will have to expire their individual assignments.<br/>
                                    <strong>Note:</strong> In most cases it is recommended that you manage the publishing via the posting windows
                                </p>
                                <control name="UNPUBLISH_BUTTON"></control>
                            </div>
                        </div>
                        <div v-if="visibleConfiguredTabs[record.postingId]" class="posting-tab-container">
                            <component :is="visibleConfiguredTabs[record.postingId].tabTemplateId" :record="record"></component>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <hr>
        <div class="list-bottom-controls">
            {{firstVisiblePosting}} - {{lastVisiblePosting}} of {{postingsLength}}<br/><control name="CURRENT_PAGE" :value="currentPage" :items="pages" @update:value="currentPage = $event" class="current-page"></control>
        </div>
    </div>`,
    controls: [
        {
            name: 'AFF_ORG_1',
            type: 'dropdown',
            label: 'Location',
            fields: {
                text: 'ORG_TITLE',
                value: 'rowID'
            },
            itemsSource: [{
                source: ['ec_getGrid'],
                params: {
                    gridPsp: 'org',
                    gridRecord: false,
                    gridFields: ['ORG_TITLE', 'ORG_KIND', 'ORG_KIND_ID', 'WORKFLOW_ID', 'ORG_AFFILIATED_ORG_IDS']
                }
            }],
            allowFiltering: true,
            onchange: 'newPostingOnChange',
            itemsFilter: 'this.item.ORG_KIND_ID < 1000',
            itemTemplate: `<div>{{data.ORG_TITLE}} ({{data.ORG_KIND}})</div>`
        },
        {
            name: 'AFF_ORG_2',
            type: 'dropdown',
            label: 'Program',
            fields: {
                text: 'ORG_TITLE',
                value: 'rowID'
            },
            itemsSource: [{
                source: ['ec_getGrid'],
                params: {
                    gridPsp: 'org',
                    gridRecord: false,
                    gridFields: ['ORG_TITLE', 'ORG_KIND', 'ORG_KIND_ID', 'WORKFLOW_ID', 'ORG_AFFILIATED_ORG_IDS']
                }
            }],
            allowFiltering: true,
            onchange: 'newPostingOnChange',
            itemsFilter: 'this.item.ORG_KIND_ID > 1000 && this.item.ORG_KIND_ID < 2000',
            itemTemplate: `<div>{{data.ORG_TITLE}} ({{data.ORG_KIND}})</div>`
        },
        {
            name: 'AFF_ORG_3',
            type: 'dropdown',
            label: 'Floating Org',
            fields: {
                text: 'ORG_TITLE',
                value: 'rowID'
            },
            allowFiltering: true,
            onchange: 'newPostingOnChange',
            itemsSource: [{
                source: ['ec_getGrid'],
                params: {
                    gridPsp: 'org',
                    gridRecord: false,
                    gridFields: ['ORG_TITLE', 'ORG_KIND', 'ORG_KIND_ID', 'WORKFLOW_ID', 'ORG_AFFILIATED_ORG_IDS']
                }
            }],
            itemsFilter: 'this.item.ORG_KIND_ID === 2000',
            itemTemplate: `<div>{{data.ORG_TITLE}} ({{data.ORG_KIND}})</div>`
        },
        {
            name: 'EXISTING_POSTING_MESSAGE',
            type: 'danger',
            display: false,
            cssClass: 'existing-posting-warning-message',
            text: `<i class="fa-solid fa-triangle-exclamation" style="margin-right: 10px;">{{}}</i><strong>Note:</strong> The Web Posting you are trying to create already exists.`
        },
        {
            name: 'NEW_POSTING_BUTTON',
            type: 'button',
            label: 'New',
            onclick: 'openCreatePostingDialog',
            cssClass: 'e-primary new-btn'
        },
        {
            name: 'SAVE_ALL',
            type: 'button',
            label: 'Save All Changes',
            helpText: 'Click this button if you\'ve edited multiple web postings without saving.',
            onclick: 'manualSave',
        },
        {
            name: 'UNPUBLISH_BUTTON',
            type: 'button',
            label: 'Expire Posting',
            onclick: 'unpublishPosting',
        },
        {
            name: 'DISPLAY_IN_SEARCH',
            type: 'radio',
            label: 'Display in Search',
            inlineLabel: true,
            showInline: true,
            disabled: true,
            display: false,
            default: 'windows',
            fields: {
                text: 'text',
                value: 'value',
            },
            items: [
                { text: 'Hidden', value: 'hide' },
                { text: 'Always', value: 'always' },
                { text: 'Using Dates', value: 'dates' },
                { text: 'Using Posting Window Dates', value: 'windows' },
            ]
        },
        {
            name: 'NEW_AVAILABILITY_WINDOW',
            type: 'button',
            label: 'New Window',
            cssClass: 'e-primary',
            onclick: 'newAvailabilityWindow',
        },
        {
            name: 'UPDATE_AVAILABILITY_WINDOW',
            type: 'button',
            label: 'Save',
            cssClass: 'e-primary',
            icon: 'fa-delete',
            onclick: 'updateAvailabilityWindow',
        },
        {
            name: 'DELETE_AVAILABILITY_WINDOW',
            type: 'button',
            label: 'Delete',
            cssClass: 'delete-button',
            icon: 'fa-solid fa-trash-can-xmark',
            onclick: 'deleteAvailabilityWindow',
        },
        {
            name: 'EDIT_DETAILS_BUTTON',
            type: 'button',
            onclick: 'editDetails',
            cssClass: 'e-primary',
        },
        // Sub controls for availability windows
        {
            name: 'AAW_DISPLAY_START_DATE',
            type: 'date',
            label: 'Display Start Date',
            onchange: 'setModifiedWindow',
            width: '200px',
        },
        {
            name: 'AAW_DISPLAY_END_DATE',
            type: 'date',
            label: 'Display End Date',
            onchange: 'setModifiedWindow',
            width: '200px',
        },
        {
            name: 'AAW_SIGNUP_START_DATE',
            type: 'date',
            label: 'Start Date/Time',
            onchange: 'setModifiedWindow',
            width: '200px',
        },
        {
            name: 'AAW_SIGNUP_END_DATE',
            type: 'date',
            label: 'End Date/Time',
            onchange: 'setModifiedWindow',
            width: '200px',
            helpText: 'Leave blank to display until full.'
        },
        {
            name: 'AAW_SIGNUP_START_TIME',
            type: 'time',
            label: 'Start Time',
            onchange: 'setModifiedWindow',
            cssClass: 'time-control',
            width: '100px',
            hideLabel: true,
            valueAsNumber: true
        },
        {
            name: 'AAW_SIGNUP_END_TIME',
            type: 'time',
            label: 'End Time',
            onchange: 'setModifiedWindow',
            cssClass: 'time-control',
            width: '100px',
            hideLabel: true,
            valueAsNumber: true
        },
        {
            name: 'AAW_MAX_VOLUNTEERS',
            type: 'number',
            min: 1,
            label: 'Max Volunteers',
            onchange: 'setModifiedWindow',
            width: '160px',
            cssClass: 'max-openings-control'
        },
        {
            name: 'showInactivePostings',
            inlineLabelReverse: true,
            type: 'boolean',
            label: 'Show Inactive Postings',
            default: false
        },
        {
            name: 'CURRENT_PAGE',
            label: 'Current Page',
            type: 'dropdown',
            width: '140px',
            default: 1,
            min: 1,
            hideLabel: true,
            showClearButton: false,
            cssClass: 'e-outline current-page',
            fields: {
                text: 'text',
                value: 'value'
            }
        }
    ]
};

const webPostingManagerCmp = {
    name: "webPostingManager",
    editorSettings: editorSettings,
    props: {},
    data() {
        return {
            templateData: {},
            localAvailabilityWindows: {},
            availablePrograms: [],
            templateUniqueId: library.getUniqueID(),
            availabilityWindowsSub: false,
            postingsSubscription: false,
            modifiedWindows: {},
            VUE_PROJECT_NAME: typeof VUE_PROJECT_NAME !== 'undefined' ? VUE_PROJECT_NAME : '',
            showingDetails: {},
            currentPage: 1,
            filtering: false,
            filteredItems: [],
            filterOptions: {
                any: {
                    label: 'Keyword',
                    type: 'string'
                },
                TITLE: {
                    label: 'Title',
                    type: 'string'
                },
                AFF_STATUS: {
                    label: 'Web Status',
                    placeholder: 'Click here to select posting status',
                    type: 'boolean'
                }
            },
            showCreateNewPosting: false
        };
    },
    computed: {
        loadingWindows() {
            return this.availabilityWindowsSub.loading;
        },
        contextOrg() {
            const recordPsp = 'org';
            let recordId = this.contextOrgId;
            if (!recordId) return {};
            let fields = ["ATTACHURL#Image", "ORG_SHORT_DESCRIPTION", "ORG_LONG_DESCRIPTION", "ORG_TITLE", "ORG_KIND_ID", "CA#Website/Type_of_service#ICON"];
            let payload = {
                source: ['sds_getProfileField'], params: { recordPsp, recordId, fields }
            };
            let subscription = this.recordStore.subscribe(payload, this.cId, false, false);
            let records = library.cloneObj(this.recordStore.getSubscription(subscription.key));
            return records[recordId];
        },
        tabTemplates() {
            let createComp = (tab, tabIndex) => {
                let iTemplateCmpId = "tabTemplate_"
                    + this.cId.replace(" ", /_/g).toLowerCase()
                    + "_" + tabIndex
                    + "_" + this.templateUniqueId;
                let iTemplate = "<div>" + tab.tabTemplate + "</div>";
                let component = this;
                let recordStore = this.recordStore;
                vueApp.component(iTemplateCmpId, {
                    template: iTemplate,
                    data() {
                        return {
                            templateData: {}, // A place to put custom, local, template specific settings
                            component: component
                        };
                    },
                    props: {
                        hovered: {
                            type: Boolean,
                            default: false
                        },
                        targeted: {
                            type: Boolean,
                            default: false
                        },
                        record: {
                            type: Object,
                            default() {
                                return {};
                            }
                        },
                        index: {}
                    },
                    computed: {
                        moment() {
                            return library.getMomentObj();
                        },
                        actionStore() {
                            return actionStore;
                        },
                        records() {
                            return recordStore.records;
                        }
                    },
                    methods: {
                        trimHTML(str) {
                            return library.trimHTML(str);
                        },
                        dateDetails(dateStr, formatStr) {
                            let momentDate = library.getMoment(dateStr, formatStr);
                            return {
                                D: momentDate.format('D'),
                                MMM: momentDate.format('MMM'),
                                dddd: momentDate.format('dddd'),
                            };
                        },
                        toggleDelay(time, property) {
                            this.templateData[property] = !this.templateData[property];
                            setTimeout(() => {
                                this.templateData[property] = !this.templateData[property];
                            }, parseInt(time, 10));
                        }
                    }
                });
                return iTemplateCmpId;
            };
            let tmpTabs = this.config.tabs || [];
            return tmpTabs.map((tab, tabIndex) => createComp(tab, tabIndex));
        },
        visibleConfiguredTabs() {
            let output = {};
            let postingIds = Object.keys(this.existingPostings);
            if (!this.tabTemplates) return output;
            let tmpTabs = this.config.tabs || [];
            tmpTabs.forEach((tab, tabIndex) => {
                let templateId = 'tabTemplate_'
                    + this.cId.replace(" ", /_/g).toLowerCase()
                    + "_" + tabIndex
                    + "_" + this.templateUniqueId;
                postingIds.forEach((postingId) => {
                    if (this.templateData[postingId].currentView === tab.tabName) {
                        output[postingId] = {
                            tabName: tab.tabName,
                            tabTemplateId: templateId
                        };
                    }
                });
            });
            return output;
        },
        recruiterUrl() {
            let url = '/custom/' + this.recruiterSettings.RECRUITER_ID;
            if (!this.configStore.devDashLocalInstanceDetails) {
                configStore.getDevDashLocalInstanceDetails();
                let tmpProjectsUrl = PROJECTS_URL.slice(0, -1); // Remove the last /
                return tmpProjectsUrl + url;
            }
            return this.configStore.devDashLocalInstanceDetails.url + url;
        },
        existingPostings() {
            let payload = {
                source: 'sds_getAffiliationList',
                params: {
                    fields: {
                        3: ["ATTACHURL#Image", "ORG_SHORT_DESCRIPTION", "ORG_LONG_DESCRIPTION", "ORG_TITLE", "ORG_KIND", "ORG_KIND_ID", "CA#Website/Type_of_service#ICON"],
                        32: ["DETAIL_RECORD_ID"]
                    },
                    orgId: this.contextOrgId,
                    affType: 'org_org'
                }
            };
            if (!this.postingsSubscription) this.postingsSubscription = this.recordStore.subscribe(payload, this.cId, false, false);
            let records = library.cloneObj(this.recordStore.getSubscription(this.postingsSubscription.key));
            const output = {};
            for (let i in records) {
                // Set some front-end fields
                let affId = records[i].AFFILIATION_ID;
                records[i].postingId = affId;
                let org1Id = records[i].AFF_RECORDS[3][0];
                let org2Id = records[i].AFF_RECORDS[3][1];
                let floatingOrgId = records[i].FLOATING_ORGANIZATION_ID;
                records[i].org1Title = records[i]?.AFFILIATED_ORGS?.[org1Id]?.ORG_TITLE;
                records[i].org2Title = records[i]?.AFFILIATED_ORGS?.[org2Id]?.ORG_TITLE;
                if (records[i]?.FLOATING_ORGANIZATION_ID) {
                    records[i].floatingOrgTitle = records[i]?.AFFILIATED_ORGS?.[floatingOrgId]?.ORG_TITLE;
                }
                output[affId] = records[i];
                if (!this.templateData[affId]) {
                    this.templateData[affId] = {
                        status: 'Active',
                        detailRecordLoading: false,
                        expandedWindows: {}
                    };
                }
            }
            return output;
        },
        mappedPostings() {
            // No mapping
            return Object.values(this.existingPostings);
        },
        firstVisiblePosting() {
            let first = (this.currentPage * 20) - 19;
            if (first < 1) first = 1;
            return first;
        },
        lastVisiblePosting() {
            let last = this.firstVisiblePosting + 19;
            if (last > this.postingsLength) last = this.postingsLength;
            return last;
        },
        visiblePostings() {
            let visiblePostings = this.filteredItems;
            let start = this.firstVisiblePosting - 1;
            let end = this.lastVisiblePosting;
            return visiblePostings
                .sort((a, b) => {
                    // Compare title 1
                    if (a.org1Title !== b.org1Title) return a.org1Title.localeCompare(b.org1Title);
                    // Compare title 2
                    if (a.org2Title !== b.org2Title) return a.org2Title.localeCompare(b.org2Title);
                    // Compare floating org
                    if (a.org2Title === b.org2Title && !a.floatingOrgTitle && !b.floatingOrgTitle) return 1;
                    if (a.floatingOrgTitle && !b.floatingOrgTitle) return 1;
                    if (!a.floatingOrgTitle && b.floatingOrgTitle) return -1;
                    if (a.floatingOrgTitle && b.floatingOrgTitle) return b.floatingOrgTitle.localeCompare(a.floatingOrgTitle);
                    return 0;
                })
                .slice(start, end);
        },
        availabilityWindows() {
            let output = {};
            if (!Array.isArray(this.visiblePostings)) return output;
            let affIds = this.visiblePostings.map((posting) => posting.AFFILIATION_ID);
            affIds = affIds.filter((affId) => this.showingDetails[affId]);
            if (!affIds) return output;
            if (!this.availabilityWindowsSub) {
                let subscription = this.recordStore.subscribe({
                    source: 'sds_getAffAvailabilityWindows',
                    params: { affIds }
                });
                this.availabilityWindowsSub = subscription;
            }
            let records = this.recordStore.getSubscription(this.availabilityWindowsSub.key);
            // Merge local-only records while we wait for the subscription to update
            for (let aawId in this.localAvailabilityWindows) {
                if (aawId === 'length') continue;
                let wRecord = this.localAvailabilityWindows[aawId];
                if (!records[aawId]) records[aawId] = wRecord;
            }
            records = records ? Object.values(records) : [];
            affIds.forEach((affId) => {
                affId = Number(affId);
                if (!output[affId]) output[affId] = {};
                let affWindows = records.filter((record) => record.AFFILIATION_ID === affId);
                // Set control values in the aff windows
                affWindows.forEach((wRecord) => {
                    let aawId = wRecord.AFF_AVAILABILITY_WINDOW_ID;
                    let fields = Object.keys(wRecord);
                    if (!wRecord.valuesLoaded) wRecord.valuesLoaded = {};
                    fields.forEach((field) => {
                        let controlName = field + '__' + aawId + '__' + affId;
                        let control = this.controls[controlName];
                        if (!wRecord.valuesLoaded[field]) {
                            if (control) {
                                wRecord.valuesLoaded[field] = true;
                                control.value = wRecord[field];
                            }
                        }
                        else {
                            // Set the new record value from the control
                            if (control) wRecord[field] = control.value;
                        }
                    });
                    wRecord.aawId = aawId;
                    output[affId][aawId] = wRecord;
                });
            });
            return output;
        },
        showInactivePostings() {
            return this.controls.showInactivePostings.value;
        },
        postingsLength() {
            return this.mappedPostings.length;
        },
        pages() {
            let pages = [];
            let visibleCount = 20;
            let pageCount = Math.ceil(this.filteredItems.length / visibleCount);
            for (let i = 0; i < pageCount; i++) {
                let pageItem = {
                    text: 'Page ' + (i + 1),
                    value: i + 1
                };
                pages.push(pageItem);
            }
            return pages;
        }
    },
    methods: {
        onLoad() {
            this.$watch('contextOrg.ORG_KIND_ID', function () {
                this.resetNewPostingControls();
            }, { immediate: true });
        },
        resetNewPostingControls() {
            library.hideDialog('createWebPosting');
            this.controls.EXISTING_POSTING_MESSAGE.display = false;
            delete this.controls.AFF_ORG_1.value;
            delete this.controls.AFF_ORG_2.value;
            delete this.controls.AFF_ORG_3.value;
            if (!this.contextOrgId) return;
            this.controls.AFF_ORG_1.disabled = true;
            this.controls.AFF_ORG_2.disabled = true;
            this.controls.AFF_ORG_3.disabled = true;
            let contextOrgKind = this.contextOrg?.ORG_KIND_ID;
            if (contextOrgKind) {
                if (contextOrgKind < 800) {
                    this.controls.AFF_ORG_1.value = this.contextOrgId;
                    this.controls.AFF_ORG_2.disabled = false;
                    this.controls.AFF_ORG_3.disabled = false;
                }
                if (contextOrgKind > 800) {
                    this.controls.AFF_ORG_2.value = this.contextOrgId;
                    this.controls.AFF_ORG_1.disabled = false;
                    this.controls.AFF_ORG_3.disabled = false;
                }
                if (contextOrgKind === 2000) {
                    this.controls.AFF_ORG_3.value = this.contextOrgId;
                    this.controls.AFF_ORG_1.disabled = false;
                    this.controls.AFF_ORG_2.disabled = false;
                }
            }
        },
        openCreatePostingDialog() {
            let dialogSettings = {
                title: 'New Web Posting',
                name: 'createWebPosting',
                doNotCloseOnFuncFailure: true,
                // okButtonCssClass: 'hide',
                // cancelButtonCssClass: 'hide',
                // preventCloseOnBackdropClick: true,
                // closeAfterSeconds: 1,
            };
            let newPostingDialogTemplate = {
                name: 'createWebPosting',
                template: `<div>
                        <div id="NEW_POSTING_CONTROLS"></div>
                    </div>`,
                data() {
                    return {};
                },
                components: {
                    control: defineAsyncComponent(() => import('@common/control/control.vue'))
                }
            };
            this.showCreateNewPosting = false;
            let closeFunction = () => {
                this.showCreateNewPosting = false;
                this.resetNewPostingControls();
            };
            library.showDialog(newPostingDialogTemplate, this.createPosting, false, dialogSettings, false, closeFunction);
            setTimeout(() => {
                this.showCreateNewPosting = true;
            }, 500);
        },
        checkExistingPostings() {
            let orgId1 = this.controls.AFF_ORG_1?.value;
            let orgId2 = this.controls.AFF_ORG_2?.value;
            let orgId3 = this.controls.AFF_ORG_3?.value;
            let orgCount = 0;
            if (orgId1) orgCount++;
            if (orgId2) orgCount++;
            if (orgId3) orgCount++;
            let existingMatch = false;
            for (let affId in this.existingPostings) {
                let affOrgs = this.existingPostings[affId]?.AFF_RECORDS[3];
                if (!affOrgs || affOrgs.length !== orgCount) continue;
                if (orgId1 && affOrgs.indexOf(orgId1) === -1) continue;
                if (orgId2 && affOrgs.indexOf(orgId2) === -1) continue;
                if (orgId3 && affOrgs.indexOf(orgId3) === -1) continue;
                existingMatch = true;
            }
            return existingMatch;
        },
        newPostingOnChange() {
            this.controls.EXISTING_POSTING_MESSAGE.display = false;
        },
        async createPosting() {
            let orgId1 = this.controls.AFF_ORG_1?.value;
            let orgId2 = this.controls.AFF_ORG_2?.value;
            let orgId3 = this.controls.AFF_ORG_3?.value;
            let response = { status: 'failure' };
            if (orgId1 || orgId2 || orgId3) { // TODO: Allow single org entry point?
                // Check for an existing matching posting
                if (this.checkExistingPostings()) {
                    this.controls.EXISTING_POSTING_MESSAGE.display = true;
                    setTimeout(() => {
                        this.controls.EXISTING_POSTING_MESSAGE.display = false;
                    }, 15000);
                    return response;
                }
                let affiliationFields = {
                    AFF_STATUS: 4 // active
                };
                // let response = await this.sDs.post('sds_createAffiliation', false, this.contextOrgId, affiliationFields, this.controls.NEW_POSTING_DROPDOWN.value);
                let doNotCreateAssignment = true;
                let runAutomations = true;
                response = await this.sDs.post('sds_createAffiliation', false, orgId1, affiliationFields, orgId2, doNotCreateAssignment, runAutomations, false, orgId3);
                if (response.status === 'success') {
                    library.showToast('Posting created successfully.');
                    this.recordStore.renewSubscriptions({ force: true, subscriptionKey: this.postingsSubscription.key });
                }
            }
            return response;
        },
        async unpublishPosting(affId) {
            let response = await this.sDs.post('sds_updateAffiliation', affId, { AFF_STATUS: 'expired' });
            if (response.status === 'success') library.showToast('Posting removed successfully.');
        },
        async newAvailabilityWindow(_event, _control, affId) {
            let response = await this.sDs.post('sds_createAffAvailabilityWindow', affId, {});
            if (response.status === 'success') {
                // put the posting into the interface
                let windowId = response.data;
                let windowObj = {
                    aawId: windowId,
                    AFF_AVAILABILITY_WINDOW_ID: windowId,
                    AFFILIATION_ID: Number(affId)
                };
                this.recordStore.records.aaw[windowId] = windowObj;
                this.localAvailabilityWindows[windowId] = windowObj;
                this.reloadAvailabilityWindowsSub();
            }
        },
        reloadAvailabilityWindowsSub() {
            // TODO remove this function and just use the recordStore setModified
            if (this.availabilityWindowsSub) {
                this.recordStore.subscribe(false, false, false, this.availabilityWindowsSub.key);
            }
        },
        setModifiedWindow(_event, control) {
            // We are using the control name to get our IDs
            let ids = control.name.split('__');
            if (!Array.isArray(ids) || ids.length < 3) return; // NOSONAR
            let [_name, aawId, affId] = ids; // NOSONAR
            if (!this.modifiedWindows[affId]) this.modifiedWindows[affId] = {};
            if (!this.modifiedWindows[affId][aawId]) this.modifiedWindows[affId][aawId] = {};
            this.modifiedWindows[affId][aawId][_name] = control.value;
        },
        async checkModifiedWindows() {
            // Check to see if any window was changed, and update it
            let promises = [];
            for (let affId in this.modifiedWindows) { // affId is org_org aff aka web posting ID
                if (affId === 'length' || typeof this.modifiedWindows[affId] !== 'object') continue;
                // Update the recordStore first, because we are using it in this.updateAvailabilityWindow
                let modifiedWindowIds = [];
                for (let aawId in this.modifiedWindows[affId]) {
                    if (aawId !== 'length') modifiedWindowIds.push(aawId);
                }
                // Update the record in the recordStore and trigger changes to computed availabilityWindows
                recordStore().setModified({ aaw: modifiedWindowIds });
                for (let aawId in this.modifiedWindows[affId]) {
                    // recordStore().setModified({ aaw: [Object.keys(this.modifiedWindows[affId])] });
                    if (aawId === 'length') continue;
                    promises.push(this.updateAvailabilityWindow(false, false, [aawId, affId]));
                }
            }
            return library.promiseAllSettled(promises);
        },
        async updateAvailabilityWindow(_event, _control, params) {
            let [aawId, affId] = params;
            if (!affId || !aawId) {
                library.showToast('There was a problem updating this Availability Window');
                return { status: 'failure', message: 'No Aff ID or Availability Window ID' };
            }
            let windowDetails = this.modifiedWindows?.[affId]?.[aawId];
            if (typeof windowDetails !== 'object') {
                library.showToast('No changes found.');
                return { status: 'failure', message: 'No window found' };
            }
            let response = await this.sDs.post('sds_updateAffAvailabilityWindow', aawId, windowDetails);
            if (response.status === 'success') {
                library.mergeObj(recordStore().records.aaw[aawId], windowDetails);
                recordStore().setModified({ aaw: [aawId] });
                library.showToast('Record updated successfully.');
                delete this.modifiedWindows[affId][aawId];
            }
            return response;
        },
        async deleteAvailabilityWindow(_event, _control, params) {
            let [aawId, affId] = params;
            let response = await this.sDs.post('sds_deleteAffAvailabilityWindow', aawId);
            if (response.status === 'success') {
                // Update in recordStore
                this.recordStore.deleteRecord({ aaw: [aawId] });
                delete this.localAvailabilityWindows[aawId];
                this.reloadAvailabilityWindowsSub();
                library.showToast('Record removed successfully.');
            }
        },
        async editDetails(_event, _control, affId) {
            if (this.templateData[affId].detailRecordLoading) return false;
            let affRecord = this.existingPostings[affId];
            let recordId = affRecord.DETAIL_RECORD_ID
                && affRecord.DETAIL_RECORD_ID.length
                && affRecord.DETAIL_RECORD_ID[0];
            // Create New if no recordId or update existing
            if (!recordId) {
                // Create the detail record, attach it to the affiliation, then open the edit profile window for the detail record
                this.templateData[affId].detailRecordLoading = true;
                let res1 = await this.sDs.post('sds_createDetailRecord', []);
                if (res1.status === 'failure') return library.showToast('There was a problem loading this information.');
                recordId = res1.data;
                actionStore.openProfile({ recordPsp: 'org', recordId });
                let res2 = await this.sDs.post('sds_updateAffiliation', affId, { DETAIL_RECORD_ID: recordId });
                if (res2.status === 'failure') return library.showToast('There was a problem loading this information.');
                library.mergeObj(recordStore().records.aff[affId], { DETAIL_RECORD_ID: [recordId] });
                recordStore().setModified({ aff: [affId] });
                setTimeout(() => {
                    this.templateData[affId].detailRecordLoading = false;
                }, 100);
            } else {
                this.templateData[affId].detailRecordLoading = true;
                actionStore.openProfile({ recordPsp: 'org', recordId });
                setTimeout(() => {
                    this.templateData[affId].detailRecordLoading = false;
                }, 5000);
            }
            return true;
        },
        // async getPostingDetails(org1Id, org2Id) {
        //     if (!org1Id || !org2Id) return;
        //     let response = await this.sDs.post('sds_getOrgRelationshipList', org1Id, false, ['ORG_TITLE', 'ORG_KIND_ID']);
        // },
        async manualSave() {
            return this.checkModifiedWindows();
        },
        filteredItemsUpdated() {
            this.currentPage = 1;
        },
        copyLink(postingId) {
            let fullLink = this.recruiterUrl + '/affiliation_details/' + postingId;
            this.templateData[postingId].linkCopied = true;
            setTimeout(() => {
                this.templateData[postingId].linkCopied = false;
            }, 4000);
            library.copyTextToClipboard(fullLink);
        },
        expandAaw(postingId, aawId) {
            this.templateData[postingId].expandedWindows[aawId] = !this.templateData[postingId].expandedWindows[aawId];
        },
    },
    components: {
        condensedFilter: defineAsyncComponent(() => import('@common/condensedFilter/condensedFilter.vue')),
    }
};
componentStore.initComponent(webPostingManagerCmp, webPostingManagerConfig);

export { webPostingManagerConfig, webPostingManagerCmp };
export default webPostingManagerCmp;
</script>

<style scoped>
.detail-record-loading-indicator {
    text-align: center;
    padding: 7px 0;
    font-weight: bold;
    color: #666;
}
.status-indicator {
    width: fit-content;
    height: fit-content;
    padding: 0.25rem 0.5rem;
    border-radius: 6px;
}
.status-indicator.active {
    background: oklch(72.3% 0.219 149.579 / 0.15);
    color: oklch(52.7% 0.154 150.069);
}
.status-indicator.inactive {
    background: oklch(70.7% 0.022 261.325 / 0.25);
    color: oklch(37.3% 0.034 259.733);
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}
:deep(.new-btn) {
    font-size: 25px;
    padding: 8px 22px;
    border-radius: 5px;
    text-transform: capitalize;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.top-controls-container {
    margin: 15px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 1.2rem;
}
.search-controls {
    flex-grow: 9;
}
.search-controls:first-child {
    width: 100%;
}
:deep(.condensed-filter) {
    flex-grow: 9;
}
/* From Component Config CSS */
.item-list-container {
    border: 0 none;
}
.posting-item {
    container-type: inline-size;
    width: 100%;
    padding: 1rem;
    font-size: 1.1rem;
    border: 1px solid #64a1e5;
    border-right: 5px solid #98bbe1;
    margin: 5px 0;
    border-radius: 5px;
    background: linear-gradient(135deg, #eff7fc 0%, #f9f9f9 24%, #ffffff 80%, #e8f2f9 100%);
}
.aff-org-image-container {
    width: 230px;
    min-width: 230px;
    margin-right: 20px;
}
.aff-org-image {
    width: 110px;
    height: 110px;
    border: 3px solid black;
    object-fit: cover;
    border-radius: 50%;
    vertical-align: top;
    background: #bfbfbf;
    color: #bfbfbf;
    display: inline-block;
}
.aff-org-image + .aff-org-image {
    margin-left: -40px;
    margin-top: 10px;
    position: relative;
    width: 150px;
    height: 150px;
}
.aff-org-image + .aff-org-image + .aff-org-image {
    margin-left: 20px;
    margin-top: -65px;
    position: relative;
    width: 80px;
    height: 80px;
    vertical-align: bottom;
    font-size: 30px;
    color: white;
    font-weight: bold;
    line-height: 80px;
    text-align: center;
}
@container (max-width: 800px) {
    .aff-org-image-container {
        width: 160px;
        min-width: 160px;
    }
    .aff-org-image {
        width: 70px;
        height: 70px;
    }
    .aff-org-image + .aff-org-image {
        margin-left: -10px;
        margin-top: 10px;
        position: relative;
        width: 90px;
        height: 90px;
    }
    .aff-org-image + .aff-org-image + .aff-org-image {
        margin-left: 10px;
        margin-top: -40px;
        width: 70px;
        height: 70px;
    }
}
@container (max-width: 600px) {
    .aff-org-image-container {
        width: 80px;
        min-width: 80px;
    }
    .aff-org-image {
        width: 60px;
        height: 60px;
        margin-left: 10px;
    }
    .aff-org-image + .aff-org-image {
        margin-left: 0;
        margin-top: -10px;
        position: relative;
        width: 80px;
        height: 80px;
    }
    .aff-org-image + .aff-org-image + .aff-org-image {
        margin-left: 10px;
        margin-top: -10px;
        width: 60px;
        height: 60px;
    }
}
.posting-window-details {
    display: flex;
    gap: 1.2rem;
    padding: .5rem;
}
.posting-window-item {
    background: #f4f4f4;
    border-bottom: 1px solid #ddd;
    position: relative;
}
.posting-window-item:nth-child(even) {
    background: #fff;
    border-bottom: 1px solid #ddd;
}
.posting-window-item :deep(label), .posting-window-item :deep(input) {
    padding: 0;
    height: 1rem;
}
.posting-window-item :deep(.label-wrapper-inner) {
    margin: 0;
}
.posting-window-item .control {
    margin-right: 1rem;
    display: inline-block;
}
.posting-window-item :deep(.time-control) {
    margin-top: 1rem;
}
.endpoint-url {
    display: inline-block;
    padding: 0.25rem 0.5rem;
    background: rgb(232, 241, 248);
    font-weight: bold;
    border-radius: 5px;
}
.endpoint-url .fa {
    color: #007bdb;
    padding-left: 10px;
}
.endpoint-url a {
    cursor: pointer;
    display: inline-block;
    padding: 0 5px 0 5px;
    margin: 0 5px;
}
.posting-title {
    margin: 0;
}
.posting-title-org {
    font-size: 1.5rem;
    display: inline-block;
}
.posting-title-name {
    display: inline-block;
    border-bottom: 1px solid #ddd;
}
.posting-tier {
    font-size: 1.2rem;
    color: #8a8a8a;
    font-style: italic;
}
.posting-title-org .aff-separator {
    color: #4f87e1;
    font-style: italic;
    margin: 0 1rem;
    display: inline-block;
}
.posting-title-org:last-child .aff-separator {
    display: none;
}
.posting-tab-container {
    margin-bottom: 10px;
    background: white;
    padding: 10px;
    border-radius: 0 0 5px 5px;
    border: 1px solid grey;
}
.posting-tabs {
    list-style: none;
    padding: 0px;
    border-bottom: 1px solid grey;
    margin-bottom: 0px;
    margin-left: 20px;
}
.posting-tabs li {
    display: inline-block;
    padding: 5px;
    border: 1px solid grey;
    border-radius: 5px 5px 0 0;
    cursor: pointer;
    position: relative;
    margin-right: 5px;
    top: 2px;
}
.posting-tabs li.active {
    display: inline-block;
    padding: 6px;
    top: 1px;
    background: #2A3D5A;
    color: white;
    font-weight: bold;
}
.vol-signup-list {
    margin: 0;
    padding-left: 0;
}
.vol-signup-list li {
    list-style: none;
    padding: 3px 0;
    border-bottom: 1px solid #ddd;
}
.action-button-container {
    float: right;
}
.description-header {
    font-size: 18px;
    margin: 10px 0;
}
.signup-dates-controls {
    display: flex;
}
.signup-dates-controls > div {
    display: flex;
}
.window-action-buttons {
    margin-left: auto;
    display: flex;
    position: relative;
    padding: .5rem;
}
.list-bottom-controls {
    text-align: center;
    font-size: 1.2rem;
    line-height: 2rem;
}
:deep(.control.e-control.current-page) {
    display: inline-block !important;
}
:deep(.control.e-control.current-page .e-input-group.e-control-wrapper) {
    font-size: 1.2rem;
    color: #284470;
}
.publish-state-indicators {
    display: flex; flex-direction: row; gap: .8rem; margin: .8rem 0;
}
.existing-posting-warning-message {
    margin-top: 1.2rem;
    font-size: 1.1rem;
}
.instructions {
    display: flex;
    gap: 1.2rem;
}
.instructions h3 {
    margin: 0;
}
.instructions > :deep(p) {
    margin: 0;
}
.instructions .fa-info-circle {
    font-size: 1.8rem;
    color: #5d8298;
}
.detail-record-info {
    color: #479a2a;
}
.help-button {
    float: right;
    text-transform: lowercase;
    opacity: 0.8;
}
</style>
